import ItemsListVue from '@/views/sic/items-list/items-list.vue';

const basePath = '/sic/items-list';
const role = 'sic'; // 角色身份

export const SIC_ITEMS_LIST_INDEX = 'sic-items-list-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ItemsListVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_ITEMS_LIST_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/items-list/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
